<div class="flex gap-2 w-full"
     [class.flex-col]="layout() === 'responsive'"
     [class.flex-row]="layout() === 'row'"
     [class.md:flex-row]="layout() === 'responsive'"
>
  <div [class]="layout() === 'row' ? 'basis-3/5 min-w-0' : 'grow-3 basis-0 min-w-0 w-full md:w-auto'">
    @if (limitControl(); as limitControl) {
      @if (inputType() === 'number') {
        <albert-inputnumber
          [controlName]="actualLimitControlName()"
          [disabled]="disabled()"
          [groupName]="limitGroupName()"
          [inputId]="limitInputId()"
          [label]="limitLabel()"
          [required]="required()"
          [showButtons]="showButtons()"
        />
      } @else {
        <albert-input
          [controlName]="actualLimitControlName()"
          [disabled]="disabled()"
          [groupName]="limitGroupName()"
          [inputId]="limitInputId()"
          [label]="limitLabel()"
          [placeholder]="placeholder()"
          [required]="required()"
        />
      }
    }
  </div>
  @if (currencyControl(); as currencyControl) {
    <div [class]="layout() === 'row' ? 'basis-2/5 min-w-0' : 'grow basis-0 min-w-0 w-full md:w-auto'">
      <albert-currency-select
        [controlName]="actualCurrencyControlName()"
        [disabled]="disabled() || currencyDisabled()"
        [groupName]="currencyGroupName()"
        [inputId]="currencyInputId()"
        [label]="currencyLabel()"
        [required]="required()"
      />
    </div>
  }
</div>
